import React from 'react';
import { Icon } from './Icon';

const AttentionIcon = ({ size }: Props) => {
  return (
    <Icon type="clock-hour-4" color="bg-label-info" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { AttentionIcon };